import React, { Component } from 'react';
import settings from './../../config/settings.json';
import { getAllUrlParams } from './../../helper/util.js';
import axios from 'axios';
import moment from 'moment';
import {
  FormattedNumber,
  intlShape,
  injectIntl
} from 'react-intl';

//import { LineChart } from 'react-chartjs';
var LineChart = require("react-chartjs").Line;

var DateRangePicker = require('react-bootstrap-daterangepicker');

class DailyStatsTable extends Component {
  getFormattedNumber(value) {
    return <FormattedNumber value={value}/>;
  }

  getFormattedNumberCurrency(value, currency) {
    return <FormattedNumber value={value} maximumFractionDigits={2} style={currency} currency="EUR"/>;
  }

  render() {
    var rows = [];
    var totalImpressions = 0;
    var totalClicks = 0;
    var totalConversions = 0;
    var totalTurnover = 0;
    var totalCosts = 0;


    for(var i = this.props.stats.length-1; i >=0; i--) {
      totalImpressions += this.props.stats[i].impressions;
      totalClicks += this.props.stats[i].clicks;
      totalConversions += this.props.stats[i].conversions;
      totalTurnover += this.props.stats[i].turnover;
      totalCosts += this.props.stats[i].costs;

      rows.push(<tr key={ i }>
              <td>{ this.props.stats[i].dd }</td>
              <td>{this.getFormattedNumber(this.props.stats[i].impressions)}</td>
              <td>{this.getFormattedNumber(this.props.stats[i].clicks)}</td>
              <td>{this.getFormattedNumber(this.props.stats[i].conversions)}</td>
              <td>{this.getFormattedNumberCurrency(this.props.stats[i].turnover, "currency")}</td>
              <td>{this.getFormattedNumberCurrency(this.props.stats[i].costs, "currency")}</td>
            </tr>);
    }
    return(
        <div className="portlet light bordered">
          <div className="portlet-body">
            <div className="table-responsive">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Impressions</th>
                    <th>Klicks</th>
                    <th>Conversions</th>
                    <th>Umsatz</th>
                    <th>Kosten</th>
                  </tr>
                </thead>
                <tbody>
                  {rows}
                </tbody>
                <tfoot>
                  <tr>
                    <th>Datum</th>
                    <th>Impressions</th>
                    <th>Klicks</th>
                    <th>Conversions</th>
                    <th>Umsatz</th>
                    <th>Kosten</th>
                  </tr>
                  <tr>
                    <th>Gesamt</th>
                    <th><FormattedNumber value={totalImpressions}/></th>
                    <th><FormattedNumber value={totalClicks}/></th>
                    <th><FormattedNumber value={totalConversions}/></th>
                    <th>{this.getFormattedNumberCurrency(totalTurnover, "currency")}</th>
                    <th>{this.getFormattedNumberCurrency(totalCosts, "currency")}</th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
    );
  }
}

class DailyStats extends Component {
  constructor() {
    super();
    this.state = {
      gotInfos: false,
      stats: false,
      graphStats: false,
      startDate: moment().subtract(30,'day'),
      endDate: moment(),
      ranges: {
				'Heute': [moment(), moment()],
				'Gestern': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
				'Letzen 7 Tage': [moment().subtract(6, 'days'), moment()],
				'Letzten 30 Tage': [moment().subtract(29, 'days'), moment()],
				'Dieser Monat': [moment().startOf('month'), moment().endOf('month')],
				'Letzter Monat': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
			}
    }

    this.handleEvent = this.handleEvent.bind(this);
  }
  loadData() {
    var apikey = getAllUrlParams().apikey;
    var url = settings.relevanz.apiBase + '/V2/stats?apikey=' + apikey + '&startdate=' + this.state.startDate.format('YYYY-MM-DD') + '&enddate=' + this.state.endDate.format('YYYY-MM-DD');
    if(apikey === undefined) {
      this.setState({
        error: {
          id: "invalid api key",
          msg: "Ihre Authentifizierungsdaten sind nicht korrekt. Bitte überprüfen Sie diese! Sollte Sie die korrekte Daten verwenden, kontaktieren Sie bitte unseren Support!"
        }
      })
    } else {
      axios.get(url).then((result) => {
        result = result.data;
        if(result.hasOwnProperty('query_result')) {
          if(result.query_result.hasOwnProperty('data')) {
            if(result.query_result.data.hasOwnProperty('rows')) {
              this.prepareGraphStats(result.query_result.data.rows);
              this.setState({
                stats: result.query_result.data.rows
              });
            }
          }
        }
        this.setState({gotInfos: true});
      }).catch((error) => {
        this.setState({
          error: {
            id: "Network error",
            msg: "Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut. Sollte der Fehler dauerhaft auftreten, wenden Sie sich bitte an unseren Support!"
          }
        });
        this.setState({gotInfos: true});
      });
    }
  }

  prepareGraphStats(data) {
    //var data = this.state.stats;
    var chartData = {
        label: "Impressions",
        labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
        datasets: [{
            label: 'Impressions',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: '#3598dc',
            borderColor: '#3598dc'
        },
        {
            label: 'Klicks',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: '#8E44AD',
            borderColor: '#8E44AD'
        },
        {
            label: 'Ausgaben',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: '#e7505a',
            borderColor: '#e7505a'
        },
        {
            label: 'Conversions',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: '#32c5d2',
            borderColor: '#32c5d2'
        },
        {
            label: 'Umsätze',
            data: [12, 19, 3, 5, 2, 3],
            fill: false,
            backgroundColor: '#c49f47',
            borderColor: '#c49f47'
        }]
    }

    var labels = [];
    var impressions = [];
    var clicks = [];
    var conversions = [];
    var turnover = [];
    var costs = [];

    for(var i = 0; i < data.length; i++) {
      labels.push(data[i].dd);

      impressions.push(data[i].impressions);
      clicks.push(data[i].clicks);
      conversions.push(data[i].conversions);
      turnover.push(Number(data[i].turnover).toFixed(2));
      costs.push(Number(data[i].costs).toFixed(2));
    }

    chartData.labels = labels;
    chartData.datasets[0].data = impressions;
    chartData.datasets[1].data = clicks;
    chartData.datasets[2].data = costs;
    chartData.datasets[3].data = conversions;
    chartData.datasets[4].data = turnover;

    this.setState({
      graphStats: chartData
    })
  }

  handleEvent(event, picker) {
  	this.setState({
  		startDate: picker.startDate,
  		endDate: picker.endDate
  	});

    this.loadData();
  }

  componentDidMount() {
    this.loadData();
  }

  render() {
    var start = this.state.startDate.format('YYYY-MM-DD');
		var end = this.state.endDate.format('YYYY-MM-DD');
		var label = start + ' - ' + end;
		if (start === end) {
			label = start;
		}

    var chartOptions = {
      responsive: true,
      title: {
        display:true,
        text:'Tagesstatistiken'
      },
      tooltips: {
          mode: 'index',
          intersect: false,
      },
      hover: {
          mode: 'nearest',
          intersect: true
      },
      legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<datasets.length; i++){%><li><span style="background-color:<%=datasets[i].strokeColor%>"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>',
      scales: {
        xAxes: [{
          display: true,
          scaleLabel: {
            display: true,
            labelString: 'Month'
          }
        }],
        yAxes: [{
          display: false,
          type: 'logarithmic'
        }]
      }
    }

    return(
      <div className="row">
        <div className="col-lg-12">
          {!this.state.gotInfos &&
            <div style={{width: "100%"}} className="text-center">
              <div className="loading-message loading-message-boxed">
                <img src="../assets/global/img/loading-spinner-grey.gif" alt=""/>
                <span>&nbsp;&nbsp;LOADING...</span>
              </div>
            </div>
          }
          {this.state.gotInfos && this.state.stats && <div className="row">
            <div className="col-lg-12">
              <div className="portlet light bordered">
                <div className="portlet-title">
                  <div className="caption">
                    <i className="icon-bar-chart font-dark">
                    </i>
                    <span className="caption-subject font-dark bold uppercase">
                      Tagesstatistiken
                    </span>
                  </div>
                </div>
                <div className="portlet-body">

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="portlet light bordered">
                        <div className="portlet-body form">

                          <form action="#" className="form-horizontal form-bordered">
                            <div className="form-body">
                              <div className="form-group">
                                <label className="control-label col-md-3">Zeitraum</label>
                                <div className="col-md-4">
                                    <DateRangePicker startDate={this.state.startDate} endDate={this.state.endDate} ranges={this.state.ranges} onEvent={this.handleEvent}>
                                      <div className="input-group" id="defaultrange">
                                        <input type="text" className="form-control" value={label} readOnly></input>
                                        <span className="input-group-btn">
                                          <button className="btn default date-range-toggle" type="button">
                                            <i className="fa fa-calendar"></i>
                                          </button>
                                        </span>
                                      </div>
                                    </DateRangePicker>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <LineChart data={this.state.graphStats} options={chartOptions} height="100"/>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <DailyStatsTable stats={this.state.stats}></DailyStatsTable>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>}

        </div>
      </div>
  )
  }
}

DailyStats.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(DailyStats);



// WEBPACK FOOTER //
// ./src/components/stats/DailyStats.js